import React, { useState } from "react";
import { Dialog } from "primereact/dialog";
import { ThemeToggle } from "../ThemeToggle/ThemeToggle";
import UnitsSystemToggler from "../UnitsSystemToggle/UnitsSystemToggle";
import {
  Content,
  SettingRow,
  SettingsButton,
  SettingsDialogGlobalStyles,
} from "./SettingsDialog.styles";

const SettingsDialog: React.FC = () => {
  const [visible, setVisible] = useState(false);

  return (
    <>
      <SettingsDialogGlobalStyles />
      <SettingsButton
        type="button"
        aria-label="Открыть настройки"
        onClick={() => setVisible(true)}
      >
        <i className="pi pi-cog" aria-hidden="true" />
      </SettingsButton>
      <Dialog
        visible={visible}
        onHide={() => setVisible(false)}
        header="Настройки системы"
        modal
        dismissableMask
        appendTo={document.body}
        className="settings-dialog"
      >
        <Content>
          <SettingRow>
            <label>Система измерений:</label>
            <UnitsSystemToggler />
          </SettingRow>
          <SettingRow>
            <label>Тема:</label>
            <ThemeToggle />
          </SettingRow>
        </Content>
      </Dialog>
    </>
  );
};

export default SettingsDialog;
